<template>
  <div class="ds-control dsf-fast-form-layout ds-no-padding pc" :class="getCss" :style="{'background-color': backgroundColor}">
    <div class="dsf-fast-form-layout_content" :columns="columns" slot-name="default">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfFastFormLayout",
  ctrlCaption: "快速表单布局",
  mixins: [$mixins.layout],
  provide() {
    return {
      $formLayoutBox: this
    }
  },
  props: {
    columns: {
      type: Number,
      default: 1
    },
    backgroundColor: {
      type: String,
      default: "#fff"
    },
    slots: {
      type: Array,
      default() {
        return [
          {
            name: "default",
            controls: []
          }
        ];
      }
    },
  },
  data() {
    return {}
  },
  computed: {
    colSpan() {
      return 24 / this.columns;
    }
  },
  methods: {

  }
});
</script>